/* eslint-disable @typescript-eslint/ban-ts-comment */
/// <reference types="cypress" />
// @ts-check
// eslint-disable-next-line @typescript-eslint/no-unused-vars
/*global Cypress*/

import {
	handleCacheStore,
	mergeWithCachedStore,
	reducers as sharedReducers,
	sagas as sharedSagas,
	whiteListReducers as sharedWhitelistReducers,
} from '@innovyze/stylovyze';
import {
	reducers as chartReducers,
	sagas as chartSagas,
} from '@innovyze/summaryze';

import {
	assetSchemaRootReducer,
	assetSchemaRootSaga,
} from '@innovyze/lib_asset_schema_store';
// @ts-ignore
import reducers from '@Reducers';
import { applyMiddleware, combineReducers, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';
import rootSaga from '../sagas';
import { moduleNamespace } from './config.store';

const reducerWhitelist = [...sharedWhitelistReducers];

declare global {
	interface Window {
		store: Store;
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		// eslint-disable-next-line @typescript-eslint/ban-types,
		Cypress: Object;
	}
}

const sagaMiddleware = createSagaMiddleware();

const initSagas = () => {
	sagaMiddleware.run(function* () {
		yield all([
			rootSaga(),
			sharedSagas(),
			chartSagas(),
			assetSchemaRootSaga(),
		]);
	});
};

const store: Store = createStore(
	combineReducers({
		...sharedReducers,
		...chartReducers,
		...assetSchemaRootReducer,
		[moduleNamespace]: reducers,
	}),
	mergeWithCachedStore(),
	composeWithDevTools(applyMiddleware(sagaMiddleware)),
);

store.subscribe(() => {
	const currentState = store.getState();
	handleCacheStore(currentState, [...reducerWhitelist]);
});

initSagas();
/* istanbul ignore else */
if (window.Cypress) window.store = store;

export default store;
